import HomeScreen from "../HomeScreen/HomeScreen";
import classplusLogo from "../../assets/Images/classplus-logo.png";
import backImage from "../../assets/Images/mobileBgOr.webp";
import rightArrow from "../../assets/Images/arrow-gray.png";
import { AndroidScreen } from "../../components/AndroidScreen";
import { useState } from "react";
import "./DesktopScreen.css";
import "../../components/Common/scss/main.scss";
import Features from "../../components/Common/Features/Features";
import Footer from "../../components/Common/Footer/Footer";
import WebinarDetails from "../../components/Common/WebinarDetails/WebinarDetails";

const DesktopScreen = () => {
  const [numberSubmitted, setNumberSubmitted] = useState(false);
  const [instituteName, setInstituteName] = useState("");
  const [showRadarScreen, setShowRadarScreen] = useState(false);

  return (
    <>
      <div className="relative h-screen flex flex-row justify-around items-center desktopScreen">
        <img
          src={classplusLogo}
          width={200}
          alt=""
          className="absolute top-8 left-12"
        />
        {/* <img src={ backImage}/> */}
        {!showRadarScreen && <div className="sauravDadaImgDesktop" />}

        <div className={`flex justify-center flex-col left`}>
          {instituteName ? (
            <>
              <h2
                className="font-bold not-italic text-4xl desktopHeading pt-20 mb-6"
                style={{ color: "#ffffff" }}
              >
                Hi, {instituteName}
              </h2>
              {numberSubmitted && (
                <div className="androidScreenWrapper">
                  <AndroidScreen
                    desktopView={true}
                    userInputs={{}}
                    instituteName={instituteName}
                  />
                </div>
              )}
            </>
          ) : (
            <>
              <h1
                className="font-bold not-italic desktopHeading pt-20 mb-6"
                style={{ color: "#ffffff" }}
              >
                Largest Free Webinar to transform ‘Teachers’ to
                ‘Teacherpreneurs’
              </h1>
              <div>
                <span style={{ fontSize: "18px" }}>
                  {/* <img src={rightArrow} alt="" className="w-4 self-start" /> */}
                  Date: 11th September 2022 <br />
                  Webinar Fee:{" "}
                  <span style={{ textDecoration: "line-through" }}>
                  ₹20,000
                  </span>{" "}
                  FREE
                  {/* REGISTER NOW  */}
                  <br />
                  <br />
                  {/* <span>Registration Fee -  */}
                  <span>
                    {" "}
                    Register now & stand a chance to win online courses worth ₹39,000 FREE!
                  </span>
                </span>
              </div>
            </>
          )}
        </div>

        <div className="right">
          <HomeScreen
            desktopView={true}
            setNumberSubmitted={setNumberSubmitted}
            setInstituteName={setInstituteName}
            showRadarScreen={showRadarScreen}
            setShowRadarScreen={setShowRadarScreen}
          />
        </div>
      </div>
      <WebinarDetails isDesktopView={true}/>
      <Features isDesktopView={true}/>
      {/* <Features /> */}
      {/* <Reach /> */}
      {/* <FeaturesList /> */}
      {/* <Institutes /> */}
      <Footer r/>
    </>
  );
};

export default DesktopScreen;
